/* Fixed-size platter planning. Product capacities are merchant-verified, never inferred. */
(function (root) {
  'use strict';
  function positiveWhole(value, max) {
    if (typeof value !== 'number' && typeof value !== 'string') return null;
    if (typeof value === 'string' && !/^\d+$/.test(value.trim())) return null;
    var number = Number(value);
    return Number.isSafeInteger(number) && number > 0 && number <= max ? number : null;
  }
  function calculate(guests, snacks, pieces) {
    var g = positiveWhole(guests, 10000);
    var s = positiveWhole(snacks, 20);
    var p = positiveWhole(pieces, 100000);
    if (g === null || s === null) return null;
    var total = g * s;
    return { total: total, platters: p === null ? null : Math.ceil(total / p), supplied: p === null ? null : Math.ceil(total / p) * p };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { calculate: calculate, positiveWhole: positiveWhole };
  if (!root.customElements || root.customElements.get('gpp-platter-calculator')) return;
  class PlatterCalculator extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.input = this.querySelector('[data-guests]');
      this.onInput = this.update.bind(this);
      this.input.addEventListener('input', this.onInput);
      this.update();
    }
    disconnectedCallback() {
      if (this.input) this.input.removeEventListener('input', this.onInput);
      this.initialized = false;
    }
    update() {
      var calculation = calculate(this.input.value, this.dataset.snacks, null);
      var error = this.querySelector('[data-error]');
      var valid = calculation !== null;
      this.input.setAttribute('aria-invalid', String(!valid));
      error.hidden = valid;
      error.textContent = valid ? '' : 'Enter a whole guest count from 1 to 10,000.';
      this.querySelector('[data-total]').textContent = valid ? calculation.total.toLocaleString() + ' snacks to plan for' : '';
      var verifiedCount = 0;
      this.querySelectorAll('[data-platter]').forEach(function (card) {
        var result = calculate(this.input.value, this.dataset.snacks, card.dataset.pieces);
        var verified = card.dataset.verified === 'true' && positiveWhole(card.dataset.pieces, 100000) !== null;
        if (verified) verifiedCount++;
        card.querySelector('[data-platter-result]').textContent = valid && verified && result ? result.platters.toLocaleString() + (result.platters === 1 ? ' platter' : ' platters') + ' · ' + result.supplied.toLocaleString() + ' snacks in total' : '';
      }, this);
      this.querySelector('[data-no-products]').hidden = verifiedCount > 0;
    }
  }
  root.customElements.define('gpp-platter-calculator', PlatterCalculator);
})(typeof window === 'undefined' ? globalThis : window);
